<template>
  <div>
    <PublicHeader v-bind="$props" />
    <div class="p-col-12 min-vh-50 mt-6rem">
      <div class="has-text-left mb-5 p-lg-4">
        <h1 class="title is-3">{{ teamName }}</h1>
      </div>

      <ProgressSpinner v-if="loading" />
      <div v-else>
        <div class="p-col-12">
          <TabView>
            <TabPanel :header="$t('roster')">
              <DataTable
                :scrollable="true"
                class="p-datatable-sm p-datatable-striped whiteBg mt-5"
                dataKey="id"
                :value="teamPlayers"
                v-if="teamPlayers.length"
              >
                <Column field="first" :header="$t('teamPlayersHeaders.first')"></Column>
                <Column field="last" :header="$t('teamPlayersHeaders.last')"></Column>
                <Column field="city" :header="$t('teamPlayersHeaders.city')"></Column>
              </DataTable>
              <p v-else>{{ $t("no-team-data") }}</p>
            </TabPanel>

            <TabPanel :header="$t('AppMenu.schedule')">
              <div v-if="games.length" class="p-col-12">
                <div v-for="g in games" :key="g[0].id" class="mt-5">
                  <h3 class="title is-4 normalWeight has-text-left">
                    {{ formatDate(g[0].start) }}
                  </h3>

                  <DataTable
                    :scrollable="true"
                    class="p-datatable-sm p-datatable-striped whiteBg mt-3"
                    dataKey="id"
                    :value="g"
                  >
                    <Column field="home_name" :header="$t('publicTeamHeader.home')"></Column>
                    <Column field="visitor_name" :header="$t('publicTeamHeader.visitor')"></Column>
                    <Column field="startTime" :header="$t('publicTeamHeader.startTime')"></Column>
                    <Column field="venue_name" :header="$t('publicTeamHeader.venue')"></Column>
                    <Column field="surface_name" :header="$t('publicTeamHeader.surface')"></Column>
                  </DataTable>
                </div>
              </div>
              <div v-else>
                <p>{{ $t("no-games-scheduled") }}</p>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
    <PublicFooter v-bind="$props" />
  </div>
</template>

<script>
import api from "@/api";
import DataTable from "primevue/datatable";
import TabPanel from "primevue/tabpanel";
import TabView from "primevue/tabview";
import Column from "primevue/column";
import PublicHeader from "@/components/PublicHeader.vue";
import PublicFooter from "@/components/PublicFooter.vue";

export default {
  metaInfo() {
    return {
      ...this.metaContent,
      title: `${this.leagueName} Teams | Diamond Scheduler`,
    };
  },
  components: { PublicFooter, PublicHeader, DataTable, Column, TabView, TabPanel },
  props: [
    "seasonId",
    "logoUrl",
    "showTeamsPage",
    "showStandingsPage",
    "showSchedulesPage",
    "showScoresPage",
    "showRostersPage",
    "domain",
    "leagueName",
    "metaContent",
  ],
  data() {
    return {
      teamName: "",
      teamPlayers: [],
      games: [],
      loading: true,
    };
  },
  methods: {
    fetchData(teamId) {
      api.getTeam(teamId).then(response => {
        this.teamName = response.data.name;
        this.teamPlayers = response.data.players.map(p => ({
          first: p.person.first,
          last: p.person.last,
          city: p.person.address.city,
        }));

        const gamesMap = {};
        response.data.games.forEach(g => {
          let day = new Date(Date.parse(g.start)).setHours(0, 0, 0, 0);
          g.startTime = this.$moment(g.start).format("HH:mm A");
          if (g.is_practice) {
            g.visitor_name = "PRACTICE";
          }
          (gamesMap[day] = gamesMap[day] || []).push(g);
        });
        this.games = Object.values(gamesMap).sort((a, b) => new Date(b[0].start) - new Date(a[0].start));
        this.loading = false;
      });
    },
    formatDate(date) {
      const options = { weekday: "long", day: "numeric", month: "long" };
      return new Date(date).toLocaleDateString("en-GB", options);
    },
  },
  watch: {
    "$route.params.team_id": function(team_id) {
      this.fetchData(team_id);
    },
  },
  mounted() {
    this.fetchData(this.$route.params.team_id);
  },
};
</script>
